var map = {
	"./Z-BOTW.jpg": 114,
	"./botwBackground.webp": 98,
	"./diablo4.jpg": 216,
	"./diablo4Bg.png": 13,
	"./edit-icon3.png": 87,
	"./edit-icon4.png": 706,
	"./horizon.jpg": 453,
	"./horizonBg.png": 608,
	"./liesOfP.jpg": 892,
	"./liesOfPBg.png": 718,
	"./list_1950715.png": 615,
	"./login-icon.png": 375,
	"./residentEvil4.jpg": 827,
	"./residentEvil4Bg.png": 193,
	"./sc5r7v.png": 17,
	"./spiderman2.jpg": 502,
	"./spierman2Bg.jpg": 776,
	"./streetFighter.jpg": 770,
	"./streetFighterBg.png": 742,
	"./trashcan2.png": 893
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;